// Loads first so the vendored jQuery plugins (Parsley, intl-tel-input's
// adapter, the multistep form) find window.jQuery.
import $ from "jquery";

window.$ = window.jQuery = $;

export default $;
